import { useMemo, useRef, useState } from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import Radio from '@mui/material/Radio'
import Typography from '@mui/material/Typography'

import { useAppSelector } from '~/store'
import { post } from '../../tools/request'

export default function SaleCSVExportSelector({ open, formats, salesFilter, onClose }) {
    const { exportDocumentsAPIURL } = useAppSelector((state) => state.initial.endpoints)
    const defaultFormatOption = useMemo(
        () => formats.find((item) => item.is_default) || formats[0],
        [formats]
    )
    const [selectedFormat, setSelectedFormat] = useState(defaultFormatOption)
    const [selectedIndex, setSelectedIndex] = useState(formats.indexOf(defaultFormatOption))
    const [displayScreen, setDisplayScreen] = useState('export')
    const [loading, setLoading] = useState(false)
    const [createdExportDocument, setCreatedExportDocument] = useState({})

    const containerRef = useRef()

    const handleToggle = (i) => () => {
        setSelectedFormat(formats[i])
        setSelectedIndex(i)
    }

    const submitSalesExport = async () => {
        setLoading(true)
        const res = await post(exportDocumentsAPIURL, {
            document_type: 'sales_export',
            status: 'waiting',
            name: 'Sale Export',
            sale_filter: salesFilter,
            document_format_id: selectedFormat.document_format_id,
            document_format_option_id: selectedFormat.document_format_option_id,
        })
        setCreatedExportDocument(res)
        setLoading(false)
        setDisplayScreen('submitted')
    }

    const handleClose = () => {
        onClose()
        setDisplayScreen('export')
        setCreatedExportDocument({})
    }

    const handleViewExports = () => {
        window.open('/home/sales/exports', '_blank')
    }

    return (
        <Dialog fullWidth maxWidth="xs" ref={containerRef} open={open} onClose={onClose}>
            <DialogTitle>{gettext('Export')}</DialogTitle>
            <DialogContent>
                {displayScreen === 'export' && (
                    <div>
                        <Typography variant="body2">{gettext('Select export type')}</Typography>
                        <List dense>
                            {formats.map(
                                (
                                    {
                                        document_format_id: id,
                                        document_format_name: name,
                                        document_format_image_url: image,
                                    },
                                    i
                                ) => (
                                    <ListItem key={i} onClick={handleToggle(i)}>
                                        <ListItemIcon>
                                            <Radio
                                                name={'choices'}
                                                value={id}
                                                inputProps={{
                                                    'aria-labelledby': `label-${name}`,
                                                }}
                                                checked={selectedIndex == i}
                                            />
                                        </ListItemIcon>
                                        <span>{name}</span>
                                        {image && (
                                            <Box
                                                component="img"
                                                id={`label-${name}`}
                                                src={image}
                                                alt={name}
                                                title={name}
                                                sx={{ maxHeight: 20, ml: 1 }}
                                            />
                                        )}
                                    </ListItem>
                                )
                            )}
                        </List>
                    </div>
                )}
                {displayScreen === 'submitted' && (
                    <Typography variant="body2" style={{ marginBottom: 24 }}>
                        {interpolate(gettext('File %s is generating'), [
                            createdExportDocument.name,
                        ])}
                    </Typography>
                )}
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                {displayScreen === 'export' && (
                    <>
                        <Button color="secondary" onClick={handleClose}>
                            {gettext('Cancel')}
                        </Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            disabled={loading}
                            onClick={submitSalesExport}
                        >
                            {gettext('Export')}
                        </Button>
                    </>
                )}
                {displayScreen === 'submitted' && (
                    <>
                        <Button color="secondary" onClick={handleClose}>
                            {gettext('Close')}
                        </Button>
                        <Button variant="contained" color="secondary" onClick={handleViewExports}>
                            {gettext('View exports')}
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    )
}
